var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 32.894h25.929V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#004165",
    d: "M16.146 10.918H9.8a1.088 1.088 0 1 1 0-2.178h6.347a1.09 1.09 0 0 1 0 2.178zm0 4.36H9.8a1.09 1.09 0 1 1 0-2.179h6.347a1.09 1.09 0 0 1 0 2.179zm0 4.358H9.8a1.089 1.089 0 1 1 0-2.179h6.347a1.09 1.09 0 0 1 0 2.179zm7.572-15.671c.017-.322-.027-1.051-.396-1.444-.074-.078-.298-.316-.933-.316H7.545c-.373.03-1.108.233-1.108 1.232l.002.935-.002.022h11.9a3.215 3.215 0 0 1 3.213 3.213v18.75c0 .247-.083.486-.238.68l-1.31 1.638h1.744a1.975 1.975 0 0 0 1.972-1.973V3.965zM2.18 7.607V29.68c0 .57.465 1.034 1.035 1.034h10.708v-4.357c0-.602.49-1.09 1.09-1.09h4.36V7.607c0-.57-.465-1.034-1.036-1.034H3.215c-.57 0-1.035.464-1.035 1.034zm13.922 22.452l2.092-2.614h-2.092v2.614zm9.82-26.012l.002 1.264v21.391a4.182 4.182 0 0 1-4.178 4.178h-3.37c-.044 0-.086-.008-.128-.013l-1.294 1.618c-.208.258-.52.409-.852.409H3.215A3.218 3.218 0 0 1 0 29.68V7.607a3.217 3.217 0 0 1 3.215-3.213h1.02l-.003-.022-.001-.935C4.23 1.03 6.18.064 7.49 0L22.39 0c1.323 0 2.12.558 2.555 1.027 1.081 1.165.99 2.833.977 3.02z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon);
export default __webpack_public_path__ + "static/media/invoices_icon.2df2b26f4effed54a4ed4e72927e6cb2.svg";
export { ForwardRef as ReactComponent };